import React, { useEffect, useState } from "react";
import styled from "styled-components";

const cars = [
  {
    name: "BMW 135i Coupé E82",
    subtitle: "2009 • Titan Silber • N54 • M Sport",
    status: "Current ownership",
    url: "https://bmw135i.sharmahemang2000.workers.dev/",
    specs: ["N54 3.0L I6", "225kW / 400Nm", "RWD"],
    meta: "3D viewer • specs • ownership record",
  },
];

const StyledSection = styled.section`
  max-width: 1260px;
  margin: 0 auto;
  padding: 0 clamp(28px, 6vw, 80px) 120px;

  .top {
    margin-bottom: 40px;
  }

  .eyebrow,
  .label {
    margin: 0 0 10px;
    color: var(--text-muted);
    font-family: var(--font-mono);
    font-size: 12px;
    letter-spacing: 0.16em;
    text-transform: uppercase;
  }

  .title {
    margin: 0;
    max-width: 760px;
    color: var(--text-primary);
    font-size: clamp(34px, 4.6vw, 58px);
    line-height: 1.06;
    letter-spacing: -0.045em;
  }

  .subsection {
    margin-top: 44px;
  }

  .subsectionHeader {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    align-items: end;
    margin-bottom: 18px;
    padding-bottom: 16px;
    border-bottom: 1px solid var(--border-light);

    @media (max-width: 760px) {
      align-items: flex-start;
      flex-direction: column;
      gap: 8px;
    }
  }

  .subsectionTitle {
    margin: 0;
    color: var(--text-primary);
    font-size: clamp(28px, 3.4vw, 42px);
    line-height: 1.06;
    letter-spacing: -0.035em;
  }

  .subsectionCopy {
    max-width: 460px;
    margin: 0;
    color: var(--text-secondary);
    font-size: 14px;
    line-height: 1.75;
  }

  .card {
    overflow: hidden;
    border-radius: 28px;
    background: rgba(255, 255, 255, 0.42);
    border: 1px solid rgba(255, 255, 255, 0.55);
    backdrop-filter: blur(18px);
    box-shadow: 0 12px 34px rgba(0, 0, 0, 0.045);
  }

  .cardBody {
    padding: 26px;
  }

  h3 {
    margin: 0 0 12px;
    color: var(--text-primary);
    font-size: clamp(28px, 3vw, 40px);
    line-height: 1.06;
    letter-spacing: -0.035em;
  }

  p {
    margin: 0;
    color: var(--text-secondary);
    font-size: 15px;
    line-height: 1.8;
  }

  .mapWrap {
    height: 500px;
    border-top: 1px solid var(--border-light);

    .map-container,
    .leaflet-container {
      height: 500px !important;
      width: 100%;
    }

    @media (max-width: 760px) {
      height: 360px;

      .map-container,
      .leaflet-container {
        height: 360px !important;
      }
    }
  }

  .garageGrid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px;

    @media (max-width: 980px) {
      grid-template-columns: 1fr;
    }
  }

  .carCard {
    display: flex;
    flex-direction: column;
    color: inherit;
    text-decoration: none;
    min-height: 100%;
    transition: var(--transition);
  }

  .carCard:hover {
    transform: translateY(-4px);
    box-shadow: 0 18px 44px rgba(0, 0, 0, 0.075);
  }

  .carTop {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    align-items: start;
  }

  .status {
    flex: 0 0 auto;
    padding: 7px 10px;
    border-radius: 999px;
    border: 1px solid var(--border-light);
    color: var(--text-secondary);
    font-family: var(--font-mono);
    font-size: 11px;
  }

  .subtitle {
    margin-top: -4px;
    font-family: var(--font-mono);
    font-size: 12px;
    color: var(--text-muted);
  }

  .specRow {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 18px;
  }

  .specPill {
    padding: 7px 10px;
    border-radius: 999px;
    border: 1px solid var(--border-light);
    color: var(--text-secondary);
    font-family: var(--font-mono);
    font-size: 11px;
  }

  .carPreview {
    position: relative;
    height: 420px;
    margin-top: auto;
    overflow: hidden;
    border-top: 1px solid var(--border-light);
    background: #050505;

    @media (max-width: 760px) {
      height: 340px;
    }
  }

  .carPreview iframe {
    width: 100%;
    height: 100%;
    border: 0;
    transform: scale(1.08);
    transform-origin: center;
    pointer-events: none;
    filter: saturate(0.95) contrast(1.05);
    transition:
      transform 700ms ease,
      filter 700ms ease;
  }

  .carCard:hover .carPreview iframe {
    transform: scale(1.16);
    filter: saturate(1.08) contrast(1.12);
  }

  .carOverlay {
    position: absolute;
    inset: 0;
    background:
      linear-gradient(to top, rgba(0, 0, 0, 0.68), rgba(0, 0, 0, 0.08) 62%),
      linear-gradient(to right, rgba(0, 0, 0, 0.34), transparent 55%);
    transition: opacity 450ms ease;
  }

  .carCard:hover .carOverlay {
    opacity: 0.72;
  }

  .carMeta {
    position: absolute;
    left: 22px;
    right: 22px;
    bottom: 22px;
    color: #ffffff;
    display: flex;
    align-items: end;
    justify-content: space-between;
    gap: 18px;
  }

  .carMetaTitle {
    margin: 0 0 6px;
    color: #ffffff;
    font-size: 24px;
    line-height: 1.05;
    letter-spacing: -0.03em;
  }

  .carMetaText {
    margin: 0;
    color: rgba(255, 255, 255, 0.72);
    font-family: var(--font-mono);
    font-size: 12px;
    line-height: 1.6;
  }

  .arrow {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    flex: 0 0 auto;
    border-radius: 999px;
    color: #ffffff;
    background: rgba(255, 255, 255, 0.14);
    border: 1px solid rgba(255, 255, 255, 0.22);
    opacity: 0;
    transform: translate(-6px, 6px);
    transition:
      opacity 350ms ease,
      transform 350ms ease,
      background 350ms ease;
  }

  .carCard:hover .arrow {
    opacity: 1;
    transform: translate(0, 0);
    background: rgba(255, 255, 255, 0.2);
  }
`;

function OdysseyMap() {
  const [ClientMap, setClientMap] = useState(null);

  useEffect(() => {
    let mounted = true;

    import("./TravelMapClient").then(mod => {
      if (mounted) setClientMap(() => mod.default);
    });

    return () => {
      mounted = false;
    };
  }, []);

  return ClientMap ? <ClientMap /> : null;
}

const OdysseyDailyDriver = () => {
  return (
    <StyledSection>
      <div className="top">
        <p className="eyebrow">Personal Systems</p>
        <h2 className="title">Systems, not hobbies.</h2>
      </div>

      <section className="subsection">
        <div className="subsectionHeader">
          <div>
            <h3 className="subsectionTitle">Odyssey</h3>
          </div>
        </div>

        <div className="card">
          <div className="mapWrap">
            <OdysseyMap />
          </div>
        </div>
      </section>

      <section className="subsection">
        <div className="subsectionHeader">
          <div>
            <h3 className="subsectionTitle">Garage</h3>
          </div>
        </div>

        <div className="garageGrid">
          {cars.map(car => (
            <a
              key={car.name}
              className="card carCard"
              href={car.url}
              target="_blank"
              rel="noreferrer"
            >
              <div className="cardBody">
                <div className="carTop">
                  <div>
                    <p className="label">Daily Driver</p>
                    <h3>{car.name}</h3>
                    <p className="subtitle">{car.subtitle}</p>
                  </div>
                  <span className="status">{car.status}</span>
                </div>

                <div className="specRow">
                  {car.specs.map(spec => (
                    <span key={spec} className="specPill">
                      {spec}
                    </span>
                  ))}
                </div>
              </div>

              <div className="carPreview" aria-hidden="true">
                <iframe src={car.url} title={`${car.name} preview`} loading="lazy" />
                <div className="carOverlay" />

                <div className="carMeta">
                  <div>
                    <h4 className="carMetaTitle">More Info</h4>
                    <p className="carMetaText">{car.meta}</p>
                  </div>

                  <span className="arrow">↗</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
    </StyledSection>
  );
};

export default OdysseyDailyDriver;